export const classes = {
  button:
    'place-start gap-2 w-80 h-10 px-4 rounded-full border border-mint-2/[.35] bg-mint-2/[.16] hover:bg-mint-2/[.24] transition-colors text-left',
  icon: 'shrink-0 text-sage-4',
  placeholder: 'text-sm text-sage-4',
};
